import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      lookupViewWrapper: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'nowrap',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        justifyContent: 'center',
        height: '500px',
        [theme.breakpoints.down('lg')]: {
          height: '1385px'
        }
      },
      inputContainer: {
        width: '675px',
        background: 'transparent',
        margin: '10px 0px 10px 0px',
        [theme.breakpoints.down('lg')]: {
          margin: '16px 0px 64px 0px'
        }
      },
      errorOverlayHeader: {
        background: 'transparent',
        width: '720px',
        fontSize: '52px',
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: 1,
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '610px',
          fontSize: '64px'
        }
      }
    })
  );
